import { Modal } from "antd";
import { useGlobalContext } from "../../context/GlobalContext";

export const ViewAttachmentModal = () => {
  const { data, updateData } = useGlobalContext();
  const { openAttachment, selectedAttachment } = data || {};

  const handleClose = () => {
    updateData({ openAttachment: false, selectedAttachment: null });
  };

  const isImage = (file: string) =>
    /\.(jpg|jpeg|png|gif|bmp|webp)$/i.test(file);

  const isPdf = (file: string) => /\.pdf$/i.test(file);

  return (
    <Modal
      open={!!openAttachment}
      onCancel={handleClose}
      footer={null}
      title="View Attachment"
      width={900}
      centered
    >
      {selectedAttachment ? (
        <div style={{ textAlign: "center" }}>
          {isImage(selectedAttachment) ? (
            <img
              src={selectedAttachment}
              alt="Attachment"
              style={{
                maxWidth: "100%",
                maxHeight: 500,
                borderRadius: 8,
                objectFit: "contain",
              }}
            />
          ) : isPdf(selectedAttachment) ? (
            <a
              href={selectedAttachment}
              download
              target="_blank"
              style={{
                color: "#1890ff",
                textDecoration: "underline",
                fontSize: 16,
              }}
            >
              Download PDF
            </a>
          ) : (
            <p>Unsupported file type</p>
          )}
        </div>
      ) : (
        <p>No attachment available</p>
      )}
    </Modal>
  );
};
